import { PopoverOrigin } from '@material-ui/core';

export type MenuPlacement = 'left' | 'right' | 'top';

interface CreateMenuPlacementReturnValue {
  anchorOrigin: PopoverOrigin;
  transformOrigin: PopoverOrigin;
}

export const createMenuPlacementObject = (placement: MenuPlacement): CreateMenuPlacementReturnValue => {
  switch (placement) {
    case 'left':
      return {
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
      };
    case 'top':
      return {
        anchorOrigin: { vertical: 'top', horizontal: 'left' },
        transformOrigin: { vertical: 'bottom', horizontal: 'left' },
      };
    case 'right':
    default:
      return {
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        transformOrigin: { vertical: 'top', horizontal: 'right' },
      };
  }
};
